'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import React from 'react';
import Typography from '@mui/material/Typography';
import { useHeaderState } from './HeaderStateContext';
import { excludeComponentProps } from '../utils/excludeComponentProps';
import { headerCssClassNames } from './headerCssClassNames';
const StyledHeaderTitle = styled(Typography, {
    ...excludeComponentProps('brandFontStack', 'breakpoint')
})(({ theme, brandFontStack }) => ({
    color: theme.tokens.FuelColorBrandPrimary,
    position: 'relative',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...brandFontStack === 'jdSans' && {
        fontFamily: theme.tokens.FuelFontFamilyJdSansProMedium,
        fontSize: theme.tokens.FuelFontSizeXl
    }
}));
export const HeaderTitle = React.forwardRef(({ children, ...props }, ref) => {
    const { title, brandFontStack } = useHeaderState();
    return (_jsx(StyledHeaderTitle, { ...props, brandFontStack: brandFontStack, className: headerCssClassNames.title, "data-fuel-size": 'lg', ref: ref, children: title }));
});
HeaderTitle.displayName = 'HeaderTitle';
